import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import styles from './styles.less';

const SelectBox = ({
  label,
  placeholder,
  value,
  options,
  disabled,
  onChange,
  filterOption,
  name,
}) => {
  const rest = {};
  if (value) {
    rest.defaultValue = value;
  }
  return (
    <Select
      version="long"
      size="large"
      dropdownClassName={styles.dropSelect}
      disabled={disabled}
      label={label}
      name={name}
      onChange={onChange}
      filterOption={filterOption}
      placeholder={placeholder}
      options={options}
      className={styles.wizard_custom}
      {...rest}
    />
  );
};

SelectBox.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  filterOption: PropTypes.func,
};

SelectBox.defaultProps = {
  label: '',
  name: '',
  placeholder: '',
  value: 1,
  options: [{ option: 1, name: 'Option 1' }],
  disabled: false,
  onChange: () => { },
  filterOption: () => { },
};

export default SelectBox;
